import { Modal } from 'antd'
import styles from './styles.module.css'
import { Icon, PrimaryButton } from '@/core/components'
import { useTranslation } from 'react-i18next'

interface IProps {
    isOpen: boolean
    confirm: () => void
    close: () => void
}
export const LogoutModal = ({ isOpen, confirm, close }: IProps) => {
    const { t } = useTranslation()
    return (
        <Modal
            styles={{ body: { width: '100%' } }}
            closeIcon={null}
            footer={null}
            classNames={{ content: styles.container }}
            open={isOpen}>
            <Icon
                onClick={close}
                name='x'
                size={24}
                color='#CED3E1'
                style={{ position: 'absolute', top: 20, right: 20 }}
            />
            <div className={styles.content_modal}>
                <p className={styles.title}>
                    {t('sureLogout')}
                    <br />
                    {`${t('toLogout')}?`}
                </p>

                <div className={styles.btn_group}>
                    <PrimaryButton
                        label={t('cancel')}
                        onClick={close}
                        className={styles.cancel_btn}
                        labelStyle={{
                            color: '#262933',
                        }}
                    />

                    <PrimaryButton
                        label={t('logout')}
                        style={{ width: '50%' }}
                        onClick={confirm}
                    />
                </div>
            </div>
        </Modal>
    )
}
